import React, { useEffect, useState, useRef } from "react";
import {
    Stack,
    Box,
    Button,
    Typography,
    Grid,
    ImageList,
    ImageListItem,
    Divider,
    ImageListItemBar,
    IconButton,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Backdrop,
    CircularProgress
} from "@mui/material";
import InfoIcon from '@mui/icons-material/Info';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import VideoChatIcon from '@mui/icons-material/VideoChat';
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import MapIcon from '@mui/icons-material/Map';
import FilePreviewModal from "../tools/Modal";
import EmailIcon from '@mui/icons-material/Email';
import ModalInfo from "../tools/ModalInfo";

const live_events_service = require('../../helpers/live_events_service')

const Inicio = () => {
    const theme = useTheme();
    const isXs = useMediaQuery(theme.breakpoints.down("sm"));
    const isMd = useMediaQuery(theme.breakpoints.between("sm", "lg"));
    const isLg = useMediaQuery(theme.breakpoints.up("lg"));
    let cols = 4;
    let cols_detalles = 2;
    if (isXs) { cols = 1; cols_detalles = 1; }
    else if (isMd) { cols = 1; cols_detalles = 1; }
    else if (isLg) { cols = 4; cols_detalles = 2; }
    const stats_arr = [
        { img: "https://escuela-bancaria.s3.us-east-2.amazonaws.com/9c616b0a-7c5a-4357-9aae-51584e68cb8d.jpeg", title: "ASISTENTES", value: "+250" },
        { img: "https://escuela-bancaria.s3.us-east-2.amazonaws.com/91e32109-0226-4148-8f04-3626d422ad6d.jpeg", title: "STANDS EXPO", value: "+10" },
        { img: "https://escuela-bancaria.s3.us-east-2.amazonaws.com/5bdf2e7f-e34a-42fa-bde3-8965eb1948ce.png", title: "PAÍSES QUE ASISTEN", value: "+20" },
        { img: "https://escuela-bancaria.s3.us-east-2.amazonaws.com/2add16c0-f13c-4879-97a8-5c01f6b07632.jpeg", title: "CONFERENCIAS", value: "+15" }
    ]
    const detalles_arr = [
        { img: "https://escuela-bancaria.s3.us-east-2.amazonaws.com/d887e158-984e-4537-9d6c-53441c9a2a8a.jpeg", title: "PROGRAMA ACADÉMICO", value: "Click para ver detalles", href: '/programa' },
        { img: "https://escuela-bancaria.s3.us-east-2.amazonaws.com/933f62f1-b423-4097-8d3f-82b2dd1800b6.jpeg", title: "MEDIA PARTNERS", value: "Click para más detalles", href: '/media-partners' },
    ]
    const varios_arr = [
        "https://escuela-bancaria.s3.us-east-2.amazonaws.com/52ae58d7-24cc-4954-ae58-e6a33590d9dd.jpeg",
        "https://escuela-bancaria.s3.us-east-2.amazonaws.com/f7bce16e-1a2c-4731-a66b-5a91ecc3eeaa.jpeg",
        "https://escuela-bancaria.s3.us-east-2.amazonaws.com/d8d7a616-dab4-44e7-853e-0fff815fceeb.jpeg",
        "https://escuela-bancaria.s3.us-east-2.amazonaws.com/431f5b17-fa11-4930-b6ef-3f0b1feb573a.jpeg",
        "https://escuela-bancaria.s3.us-east-2.amazonaws.com/451f7bb8-1d05-427e-8f18-4e94145c1e86.jpeg",
        "https://escuela-bancaria.s3.us-east-2.amazonaws.com/7b9c2c52-6f0d-40e8-acb3-a6d545b2d6a5.jpeg",
        "https://escuela-bancaria.s3.us-east-2.amazonaws.com/47129e5f-2a5e-4348-a0d5-752d53d3ecf4.jpeg",
        "https://escuela-bancaria.s3.us-east-2.amazonaws.com/620c27f5-eedc-4a94-b052-c3ee2093c749.jpeg",
        "https://escuela-bancaria.s3.us-east-2.amazonaws.com/b6010e2c-5019-4bad-b411-bf8cccc61532.jpeg",
    ]
    const [contador] = useState(0);
    const [evento, setEvento] = useState({});
    const [conferencistas, setConferencistas] = useState([]);
    const [loading, setLoading] = useState(true);
    const [open, setOpen] = useState(false);
    const [url, setUrl] = useState("");
    const [hoveredIndex, setHoveredIndex] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [info, setInfo] = useState({ conferencista: "", cv: "", foto: "", puesto: "", institucion: "", bandera: "", pais: "" });
    useEffect(() => {
        live_events_service
            .getData("/evento/view-by-hash/" + process.env.REACT_APP_EVT)
            .then((response_evt) => {
                live_events_service
                    .getData(
                        "/patrocinador/view-by-evento/" +
                        process.env.REACT_APP_EVT
                    )
                    .then((response_patrocinador) => {
                        live_events_service
                            .getData(`/conferencista/read/${process.env.REACT_APP_EVT}`)
                            .then((response) => {
                                setEvento(response_evt.data.response_database.result[0]);
                                setLoading(false);
                                setConferencistas([...new Map(response.data.response.result.filter(item => item.conferencista?.nombre != null).sort((a, b) => a.hora.localeCompare(b.hora)).map(item => [item.conferencista.nombre, item])).values()].filter((item) => item.conferencista.nombre != 'Representante'))
                            })
                            .catch((error) => {
                                console.log(error);
                            });
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            })
            .catch((error) => {
                console.log(error);
            });
    }, [contador]);

    return (
        <Stack>
            <Backdrop
                sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <Box sx={{ width: "100%", padding: '5%' }}>
                <Stack spacing={6}>
                    <Typography variant="h4" align="center" style={{ color: "#1e3d52", fontWeight: "bold", textAlign: 'center' }}>
                        III CONGRESO LATINOAMERICANO DE DESARROLLO DEL TALENTO HUMANO
                    </Typography>
                    <Divider />
                    <Typography
                        variant="h5"
                        sx={{
                            color: "#1e3d52",
                            fontWeight: "bold",
                            mb: 1,
                            textAlign: "center",
                        }}
                    >
                        Nuestras verticales estratégicas
                    </Typography>
                    <Typography
                        variant="p"
                        sx={{
                            color: "#1e3d52",
                            fontWeight: 500,
                            textAlign: "center",
                            margin: "0 auto",
                            lineHeight: 1.6
                        }}
                    >
                        LIDERAZGO EJECUTIVO Y VISIÓN ESTRATÉGICA
                        · PEOPLE ANALYTICS Y DECISIONES BASADAS EN DATOS
                        · INTELIGENCIA ARTIFICIAL APLICADA A RECURSOS HUMANOS
                        · TRANSFORMACIÓN CULTURAL, ÉTICA Y PROPÓSITO
                        · BIENESTAR ORGANIZACIONAL Y ESTRATEGIA DE TALENTO
                        · ANTIFRAGILIDAD Y GESTIÓN DEL CAMBIO
                        · TALENTO SENIOR Y GESTIÓN GENERACIONAL
                        · EXPERIENCIA DEL COLABORADOR Y FUTURO DEL TRABAJO
                        · INCLUSIÓN, DIVERSIDAD Y ALGORITMOS TRANSPARENTES
                        · SOSTENIBILIDAD, ESG Y TRANSFORMACIÓN ORGANIZACIONAL
                        · HR COMO SOCIO ESTRATÉGICO DEL NEGOCIO
                        · BANCA, TALENTO Y EVOLUCIÓN DEL SECTOR FINANCIERO
                        · BIENESTAR FINANCIERO Y SOBREENDEUDAMIENTO
                        · INNOVACIÓN EN MODELOS DE GESTIÓN HUMANA
                        · EJECUCIÓN ESTRATÉGICA Y CASOS DE ÉXITO
                    </Typography>
                </Stack>
            </Box >
              <Box sx={{ display: { xs: 'none', md: 'none', lg: 'block' } }} style={{ width: '100%', padding: '10%', backgroundImage: 'url(https://escuela-bancaria.s3.us-east-2.amazonaws.com/60679408-3bc1-4c8b-b83c-f51f6664d36a.jpeg)', backgroundSize: 'cover', backgroundPosition: 'center', textAlign: 'center' }}>
                <video controls style={{ width: '60%' }} >
                    <source
                        src="https://escuela-bancaria.s3.us-east-2.amazonaws.com/82bf89a7-ecb4-47e7-8ff8-16b20c216893.mp4"
                        type="video/mp4"                        
                    />
                </video>
            </Box>
            <Box sx={{ display: { xs: 'block', md: 'block', lg: 'none' } }} style={{ width: '100%', padding: '10%', backgroundImage: 'url(https://escuela-bancaria.s3.us-east-2.amazonaws.com/60679408-3bc1-4c8b-b83c-f51f6664d36a.jpeg)', backgroundSize: 'cover', backgroundPosition: 'center', textAlign: 'center' }}>
                <video controls style={{ width: '100%' }} >
                    <source
                        src="https://escuela-bancaria.s3.us-east-2.amazonaws.com/82bf89a7-ecb4-47e7-8ff8-16b20c216893.mp4"
                        type="video/mp4"
                    />
                </video>
            </Box>
            <Box sx={{ width: "100%", padding: '5%' }}>
                <Stack spacing={6}>
                    <Typography
                        variant="h5"
                        align="center"
                        style={{ color: "#1e3d52", fontWeight: "bold", textAlign: 'center' }}
                    >
                        ¿Cómo liderar el talento y transformar organizaciones en la era de la IA y la sostenibilidad?
                    </Typography>

                    <Typography
                        variant="p"
                        align="center"
                        style={{ color: "#1e3d52", fontWeight: "bold", textAlign: 'justify' }}
                    >

                        La inteligencia artificial, los cambios culturales y las nuevas dinámicas del trabajo están redefiniendo la forma en que las organizaciones desarrollan, lideran y potencian su talento.

                        Hoy, áreas de Recursos Humanos, líderes de negocio y alta dirección enfrentan un reto clave: evolucionar de funciones operativas a arquitectos estratégicos del futuro organizacional.

                        CLADE 2026 reúne a los líderes que están marcando el rumbo en la región: CEOs, directores de talento humano, gerentes, estrategas de negocio y especialistas en desarrollo organizacional del sector financiero y empresarial.

                        Durante dos días intensivos:

                        Descubrirás cómo aplicar IA y People Analytics para tomar mejores decisiones

                        Analizarás el impacto de la cultura, la ética y el propósito en la era digital

                        Aprenderás a liderar el cambio en entornos de alta incertidumbre y presión

                        Conocerás estrategias reales de bienestar, sostenibilidad y desarrollo del talento

                        Conectarás con líderes de Centroamérica y expertos internacionales

                        CLADE no es solo un congreso.
                        Es el espacio donde el talento se convierte en la ventaja competitiva más importante de las organizaciones.

                        Porque en un entorno que cambia constantemente, la pregunta no es si debes transformarte.
                        La pregunta es: ¿tu organización está preparada para liderar el futuro? 🚀
                    </Typography>
                </Stack>
            </Box>
            <ImageList cols={cols}>
                {stats_arr.map((item) => (
                    <ImageListItem key={item.img}>
                        <img
                            srcSet={`${item.img}?w=248&fit=crop&auto=format&dpr=2 2x`}
                            src={`${item.img}?w=248&fit=crop&auto=format`}
                            alt={item.title}
                            loading="lazy"
                        />
                        <ImageListItemBar
                            title={item.title}
                            subtitle={item.value}
                        />
                    </ImageListItem>
                ))}
            </ImageList>
            <Grid container alignItems="center" justifyContent="center" style={{ textAlign: "justify", width: '100%' }}>
                <Grid size={{ xs: 12, md: 6, lg: 6 }} sx={{ padding: { xs: '5%', md: '8%', lg: '10%' } }} style={{ backgroundColor: '#4B3FA0' }}>
                    <Stack spacing={2} >
                        <Typography variant="h4" align="center" style={{ color: "white", fontWeight: "bold", textAlign: 'justify' }}>
                            Precio Especial por Grupos
                        </Typography>
                        <Typography
                            variant="p"
                            align="center"
                            style={{ color: "white", fontWeight: "bold", textAlign: 'justify' }}
                        >
                            Reserva para ti y tu equipo el acceso a CLADE 2026 con un precio especial por grupos.
                            Asegura tu lugar en el congreso líder en desarrollo de talento humano, liderazgo e innovación organizacional en la región y aprovecha esta oportunidad exclusiva para organizaciones que buscan fortalecer su cultura, potenciar su talento y liderar la transformación en la era de la IA.
                        </Typography>
                        <List style={{ color: 'white' }}>
                            <ListItem disablePadding>
                                <ListItemButton href={
                                    process.env.REACT_APP_URL_INSCRIPCION +
                                    process.env.REACT_APP_EVT
                                } target="_blank">
                                    <ListItemIcon>
                                        <ShoppingCartIcon style={{ color: 'white' }} />
                                    </ListItemIcon>
                                    <ListItemText primary="Comprar" />
                                </ListItemButton>
                            </ListItem>
                            <ListItem disablePadding>
                                <ListItemButton href="mailto:ncuches@ebg.edu.gt?subject=Quiero%20más%20información%20sobre%20tarifa%20grupal%20de%20CLADIT%202026">
                                    <ListItemIcon>
                                        <InfoIcon style={{ color: 'white' }} />
                                    </ListItemIcon>
                                    <ListItemText primary="Solicitar más información" />
                                </ListItemButton>
                            </ListItem>
                            <ListItem disablePadding>
                                <ListItemButton href="https://ebg.edu.gt/inscripcion/ed5e8364-0841-40fd-9bc3-9a1b60c48e8e" target="_blank">
                                    <ListItemIcon>
                                        <VideoChatIcon style={{ color: 'white' }} />
                                    </ListItemIcon>
                                    <ListItemText primary="Webinar Open House CLADE 2026" />
                                </ListItemButton>
                            </ListItem>
                        </List>
                    </Stack>
                </Grid>
                <Grid size={{ xs: 12, md: 6, lg: 6 }} sx={{ padding: { xs: '5%', md: '8%', lg: '10%' } }}>
                    <Stack spacing={2} >
                        <Typography variant="h4" align="center" style={{ color: "#4B3FA0", fontWeight: "bold", textAlign: 'justify' }}>
                            Patrocinio
                        </Typography>
                        <Typography variant="p" align="center" style={{ color: "#4B3FA0", fontWeight: "bold", textAlign: 'justify' }}>
                            Reserva una de las posiciones disponibles
                        </Typography>
                        <Typography variant="h5" align="center" style={{ color: "#4B3FA0", fontWeight: "bold", textAlign: 'justify' }}>
                            Patrocinador / Stand / Speaker
                        </Typography>
                        <List style={{ color: '#4B3FA0' }}>
                            <ListItem disablePadding>
                                <ListItemButton
                                    onClick={() => { setOpen(true); setUrl(evento.evt_info_pdf) }}
                                >
                                    <ListItemIcon>
                                        <PictureAsPdfIcon style={{ color: '#4B3FA0' }} />
                                    </ListItemIcon>
                                    <ListItemText primary="Ver Brief de Patrocinios" />
                                </ListItemButton>
                            </ListItem>
                            <ListItem disablePadding>
                                <ListItemButton
                                    onClick={() => { setOpen(true); setUrl(evento.planos) }}
                                >
                                    <ListItemIcon>
                                        <MapIcon style={{ color: '#4B3FA0' }} />
                                    </ListItemIcon>
                                    <ListItemText primary="Ver Planos de Expo" />
                                </ListItemButton>
                            </ListItem>
                            <ListItem disablePadding>
                                <ListItemButton href="mailto:ncuches@ebg.edu.gt?subject=Quiero%20más%20información%20sobre%20patrocinio%20de%20CLADIT%202026">
                                    <ListItemIcon>
                                        <InfoIcon style={{ color: '#4B3FA0' }} />
                                    </ListItemIcon>
                                    <ListItemText primary="Solicitar más información" />
                                </ListItemButton>
                            </ListItem>
                            <ListItem disablePadding>
                                <ListItemButton>
                                    <ListItemIcon>
                                        <VideoChatIcon style={{ color: '#4B3FA0' }} />
                                    </ListItemIcon>
                                    <ListItemText primary="Webinar Open House CLADE 2026 -  Sponsors" />
                                </ListItemButton>
                            </ListItem>
                        </List>
                    </Stack>
                </Grid>
            </Grid>
            <img src='https://escuela-bancaria.s3.us-east-2.amazonaws.com/48fdf3e2-b7ee-491a-8ae6-3fdc57e44ab4.jpeg' style = {{width:'100%'}}/>
            <Box
                sx={{
                    width: "100%",
                    height: "600px",
                    position: "relative",
                    backgroundImage: `url("https://escuela-bancaria.s3.us-east-2.amazonaws.com/53a78163-a027-4504-833e-91fb7b69d022.jpeg")`,
                    backgroundSize: "cover",
                    backgroundPosition: "center top",
                    backgroundRepeat: "no-repeat",
                    display: "flex",
                    alignItems: "center",
                }}
            >
                {/* Overlay oscuro con degradado */}
                <Box
                    sx={{
                        position: "absolute",
                        inset: 0,
                        backdropFilter: "blur(3px)",
                        WebkitBackdropFilter: "blur(3px)", // soporte Safari
                        backgroundColor: "rgba(0,0,0,0.4)", // oscurece ligeramente
                        zIndex: 1,
                    }}
                />

                {/* Contenido */}
                <Box sx={{ position: "relative", zIndex: 2 }} p={15}>
                    <Stack spacing={1}>
                        <Typography
                            variant="h3"
                            fontWeight="bold"
                            color="white"
                            gutterBottom
                        >
                            DIRIGIDO A:
                        </Typography>
                        <Typography
                            variant="P"
                            fontWeight="bold"
                            color="white"
                            gutterBottom
                        >
                            Sector Financiero
                        </Typography>
                        <Typography
                            variant="p"
                            color="white"
                            sx={{ maxWidth: "600px", opacity: 0.9 }}
                            gutterBottom
                            style={{ textAlign: 'justify' }}
                        >
                            Dirigido a líderes y tomadores de decisión en la gestión del talento y la transformación organizacional como:
                            CEOs, directores y gerentes de talento humano, líderes de cultura y desarrollo organizacional,
                            especialistas en People Analytics, innovación y transformación digital, áreas de estrategia,
                            operaciones y negocio, así como ejecutivos del sector financiero y empresarial comprometidos
                            con el desarrollo del talento, la sostenibilidad y la evolución de sus organizaciones.
                        </Typography>
                    </Stack>
                </Box>
            </Box>
            <ImageList cols={cols_detalles}>
                {detalles_arr.map((item) => (
                    <ImageListItem key={item.img}>
                        <img
                            srcSet={`${item.img}?w=248&fit=crop&auto=format&dpr=2 2x`}
                            src={`${item.img}?w=248&fit=crop&auto=format`}
                            alt={item.title}
                            loading="lazy"
                            style={{ height: '500px', objectFit: 'cover' }}
                        />
                        <ImageListItemBar
                            title={item.title}
                            subtitle={item.value}
                            actionIcon={
                                <IconButton
                                    sx={{ color: 'rgba(255, 255, 255, 0.54)' }}
                                    aria-label={`info about ${item.title}`}
                                    href={item.href}
                                >
                                    <InfoIcon />
                                </IconButton>
                            }
                        />
                    </ImageListItem>
                ))}
            </ImageList>
            <Box
                sx={{
                    width: "100%",
                    height: "600px",
                    position: "relative",
                    backgroundImage: `url("https://escuela-bancaria.s3.us-east-2.amazonaws.com/2cdb630b-7fe3-43ec-a0fe-10288be8da1a.jpeg")`,
                    backgroundSize: "cover",
                    backgroundPosition: "center top",
                    backgroundRepeat: "no-repeat",
                    display: "flex",
                    alignItems: "center",
                }}
            >
                {/* Overlay oscuro con degradado */}
                <Box
                    sx={{
                        position: "absolute",
                        inset: 0,
                        backdropFilter: "blur(3px)",
                        WebkitBackdropFilter: "blur(3px)", // soporte Safari
                        backgroundColor: "rgba(0,0,0,0.4)", // oscurece ligeramente
                        zIndex: 1,
                    }}
                />

                {/* Contenido */}
                <Box sx={{ position: "relative", zIndex: 2 }} p={15}>
                    <Stack spacing={1}>
                        <Typography
                            variant="h3"
                            fontWeight="bold"
                            color="white"
                            gutterBottom
                        >
                            CLADE 2026
                        </Typography>

                        <Typography
                            variant="P"
                            fontWeight="bold"
                            color="white"
                            gutterBottom
                        >
                            +20 expositores
                        </Typography>

                        <Typography
                            variant="p"
                            color="white"
                            sx={{ maxWidth: "600px", opacity: 0.9 }}
                            gutterBottom
                            style={{ textAlign: 'justify' }}
                        >
                            Estrategias en liderazgo, desarrollo del talento, People Analytics, inteligencia artificial aplicada a Recursos Humanos, cultura organizacional, sostenibilidad (ESG), bienestar corporativo y transformación del negocio que impulsarán la evolución de tu organización en la nueva era.

                            Conecta con expertos internacionales, líderes empresariales y referentes del sector financiero y organizacional en CLADE 2026, y lleva tu gestión del talento y tu estrategia organizacional al siguiente nivel.
                        </Typography>
                    </Stack>
                </Box>
            </Box>

            <Box sx={{ width: "100%", padding: '5%', overflow: 'hidden' }}>
                <Stack spacing={6}>
                    <Typography variant="h4" align="center" style={{ color: "#1e3d52", fontWeight: "bold", textAlign: 'center' }}>
                        NUESTROS CONFERENCISTAS
                    </Typography>
                    <Divider />
                    <ImageList cols={cols}>
                        {conferencistas.map((item) => (
                            <ImageListItem
                                key={item.conferencista.foto_alt}
                                sx={{
                                    borderRadius: 3,
                                    overflow: "hidden",
                                    cursor: "pointer",
                                    position: "relative",
                                    transition: "box-shadow 0.3s ease",
                                    "&:hover": {
                                        boxShadow: "0 0 20px #4B3FA0",
                                    },
                                    "&:hover img": {
                                        filter: "brightness(1.05)",
                                    },
                                }}
                            >
                                <img
                                    srcSet={`${item.conferencista.foto_alt}?w=248&fit=crop&auto=format&dpr=2 2x`}
                                    src={`${item.conferencista.foto_alt}?w=248&fit=crop&auto=format`}
                                    alt={item.conferencista.nombre}
                                    loading="lazy"
                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                        display: "block",
                                        transition: "filter 0.3s ease",
                                        filter: "grayscale(100%)",
                                    }}
                                    onMouseEnter={(e) =>
                                        (e.currentTarget.style.filter = "grayscale(0%)")
                                    }
                                    onMouseLeave={(e) =>
                                        (e.currentTarget.style.filter = "grayscale(100%)")
                                    }
                                />

                                <ImageListItemBar
                                    title={item.conferencista.nombre}
                                    sx={{
                                        background:
                                            "linear-gradient(to top, rgba(0,0,0,0.8), rgba(0,0,0,0.2))",
                                    }}
                                    actionIcon={item.conferencista.cv &&
                                        <IconButton
                                            sx={{ color: 'rgba(255, 255, 255, 0.54)' }}
                                            aria-label={`info about ${item.title}`}
                                            onClick={() => {
                                                setInfo({ conferencista: item.conferencista.nombre, cv: item.conferencista.cv, foto: item.conferencista.foto_alt, puesto: item.conferencista.puesto, institucion: item.conferencista.institucion, bandera: item.conferencista.bandera, pais: item.conferencista.pais })
                                                setModalOpen(true);
                                            }}
                                        >
                                            <InfoIcon />
                                        </IconButton>
                                    }
                                />
                            </ImageListItem>
                        ))}
                    </ImageList>
                </Stack>
            </Box >
           {/* <ImageList variant="woven" cols={3} gap={8}>
                {varios_arr.map((item) => (
                    <ImageListItem key={item}>
                        <img
                            srcSet={`${item}?w=161&fit=crop&auto=format&dpr=2 2x`}
                            src={`${item}?w=161&fit=crop&auto=format`}
                            alt={"varios"}
                            loading="lazy"
                        />
                    </ImageListItem>
                ))}
            </ImageList>*/}
            <FilePreviewModal open={open} onClose={() => setOpen(false)} url={url} title="Vista previa" />
            <ModalInfo open={modalOpen} onClose={() => { setModalOpen(false) }} conferencista={info} />
        </Stack >
    );
};

export default Inicio;
